/* eslint-disable comma-dangle */

export default {
    address: [
    'user-input',
    'jk',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'common/tax-number',
        'commercial-multi-area',
        'floor-commercial',
        'ceiling-height',
        'condition-type',
        'specialty-required',
        'has-shop-windows',
        'is-legal-address-provided',
        'common/water-pipes',
        'electricity-power',
        'common/input-type',
        'is-occupied',
        'available-from',
    ],
    'about-building': [
        'name-and-year-commercial-autocomplete-no',
        'building-type',
        'total-area',
        'land',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'building-status-type',
        'building-developer',
        'building-management-company',
        'additional-items'
    ],
    'price-and-deal-terms': [
        'price-multi-sale',
        'included-options',
        'lease-type-v2',
        'min-lease-term',
        'has-grace-period',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'security-deposit',
        'prepay-type',
        'vat-type',
        'fee'
    ]
};
